import NRTitleWithRightTotal from '../../NRRightTotal/NRRightTotal';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';

function NRDrawerTile({ total, title, handleTotalClick }) {
  return (
    <Box gap={3} display={'flex'} flexDirection={'column'}>
      <Divider />
      <NRTitleWithRightTotal totalCount={total} title={title} handleTotalClick={handleTotalClick} />
    </Box>
  );
}

export default NRDrawerTile;
